export default __webpack_public_path__ + "static/media/40.605895ff.svg";